<div class="alight-table">
<table mat-table [dataSource]="dataSource" class="mat-elevation-z0 table-border" cdkDropListGroup matSort
  id="alightTable" (matSortChange)="sortChange()">

  <ng-container *ngFor="let column of columns; let i = index" [matColumnDef]="column.field">
    <th mat-header-cell *matHeaderCellDef>
      <span *ngIf="!sortRequired"> {{ column.header }}</span>
      <span *ngIf="sortRequired" mat-sort-header> {{ column.header }}</span>
      <span [ngClass]="columnHeaderCls(column)" (mousedown)="onResizeColumn($event, i)"></span>
    </th>


    <td mat-cell *matCellDef="let row" [title]="getTitle(row,column)" class="truncate"
      [ngClass]="{ red:  column['field'] == 'topic' && row[column.field] == 'Do Not Discuss'}">
      <i *ngIf="column['field'] == 'topic' && row[column.field] == 'Do Not Discuss'" [title]="row['topic']"
        class="fa-solid fa-circle-exclamation"></i>
      {{
      column.field == "dateOfBirth"
      ? (row[column.field] | date : "MM/dd/yyyy")
      : column.field == 'channelIcon'? "" : row[column.field]
      }}
      <i *ngIf="column.field == 'channelIcon'" [title]="row['title']" class="{{ row[column.field] }}"></i>

    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell" [attr.colspan]="displayedColumns.length" *ngIf="noRecord()">
      <div class="center no-result">
        <p>{{noRecordFoundMsg}}</p>
      </div>

    </td>
  </tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="onRowSingleClick(row,'', $event, tableName)"
    (dblclick)="onCustomerRowClick(row,'', $event, tableName)" (keydown.enter)="onTableRowEnter(row)"
    (focus)="selectedRow = row" [ngClass]="{ selected: row === selectedRow }" tabindex="0"></tr>
</table>
</div>
<mat-paginator [pageSizeOptions]="[rowPerPage]" [ngStyle]="{ display: 'none' }" showFirstLastButtons="true"
  hidePageSize="true" aria-label="Select page of periodic elements">
</mat-paginator>

<div class="footer-controls" *ngIf="tableData() ">
  <div class="footer-controls-left">
    <div class="admin-table-count" *ngIf="tableName == 'currentTable' || tableName == 'deleteTable'">
      <h3 class="display-result">

        Displaying
        <strong>{{totalCount }}</strong> records
      </h3>
      <!-- <h3 class="display-reult" *ngIf="totalRecords == 0">No results found</h3> -->
    </div>
    
    <div *ngIf="isShowButtons && rowPerPage == 10">
      <f-button *ngIf="!hideReplaceAddButton" text="Replace Customer" type="button" [disabled]="
      !disableButtons && selectedRow && checkForReplaceBtn() && rootScope.isGenesysLoggedIn
          ? false
          : true
      " variant="progressive" (buttonClicked)="onRowDoubleClick(selectedRow, enumButton.replaceAccount)">
      </f-button>
      <f-button *ngIf="!hideReplaceAddButton" text="Open Additional Account" type="button"
        [disabled]="checkForAdditonalbtn()" variant="progressive" (buttonClicked)="
        onRowDoubleClick(selectedRow, enumButton.additionalAccount)
      ">
      </f-button>
      <f-button text="Go to Customer Account" type="button" [disabled]="enableDisableGoToCustAcc()"
        variant="progressive" (buttonClicked)="
        onRowDoubleClick(selectedRow, enumButton.customerAccount)
      ">
      </f-button>

    </div>

  </div>
  <!-- Open Additional account buttons  -->

  <div class="footer-controls-right" *ngIf="isPagination">
    
    <!-- <mat-form-field appearance="fill" class="component-box pagination-input">
      <input
        matInput
        placeholder="1"
        maxlength="1"
        [value]="paginator.pageIndex + 1"
        (keyup)="pageNumber($event)"
      />
    </mat-form-field>
    <p>
      of <span>{{ totalPage }}</span>
    </p> -->
    <div class="custom-pagination hide1">
      <button class="arrow-btn" mat-stroked-button title="Start Page" disabled="{{ isPreviousDisabled }}"
        (click)="gotToFirstAndLastPage(true);tableFocusout()">
        <i class="fa-solid fa-chevrons-left"></i>
      </button>

      <!-- <button class="arrow-btn" mat-stroked-button title="Previous" disabled="{{ isPreviousDisabled }}"      
      (click)="previousAndNext(false);tableFocusout()" *ngIf="totalPage > 0 && totalPage <=5">
      <i class="fa-solid fa-chevron-left"></i>
    </button> -->

      <button class="arrow-btn" mat-stroked-button title="Previous" disabled="{{ isPreviousDisabled }}"      
        (click)="previousAndNext(false);tableFocusout()">
        <i class="fa-solid fa-chevron-left"></i>
      </button>

      <span *ngFor="let num of pageNumbers;">
        <button class="number" title="{{num}}" [ngClass]="paginator.pageIndex +1 == num ? 'selected' :'' "
          (click)="goToPageChange(num)" mat-stroked-button>{{num}}</button>
      </span>

      <!-- <button class="arrow-btn" mat-stroked-button title="Next" disabled="{{ isNextDisabled }}"      
      (click)="previousAndNext(true); tableFocusout()" *ngIf="totalPage > 0 && totalPage <=5">
      <i class="fa-solid fa-chevron-right"></i>
    </button> -->

      <button class="arrow-btn" mat-stroked-button title="Next" disabled="{{ isNextDisabled }}"      
        (click)="previousAndNext(true); tableFocusout()">
        <i class="fa-solid fa-chevron-right"></i>
      </button>

      <button class="arrow-btn" mat-stroked-button title="Last Page" disabled="{{ isNextDisabled }}"
        (click)="gotToFirstAndLastPage(false);tableFocusout()">
        <i class="fa-solid fa-chevrons-right"></i>
      </button>
    </div>
  </div>
</div>